interface EmployerListState {
  loading: boolean;
  loaded: boolean;
  error: string | null;
}

export function employerListMessage({ loading, loaded, error }: EmployerListState): string {
  if (error) return error;
  if (loading || !loaded) return 'Carregando empresas…';
  return 'Nenhuma empresa atribuída';
}
